import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCreatePatient } from '../../hooks/usePatients';
import { PatientForm } from '../../components/patients/PatientForm';
import { PageHeader } from '../../components/common/PageHeader';
import type { CreatePatientDto } from '../../types/patient.types';
import toast from 'react-hot-toast';

export const AddPatientPage: React.FC = () => {
  const navigate = useNavigate();
  const createPatientMutation = useCreatePatient();

  const handleSubmit = async (data: CreatePatientDto) => {
    try {
      // Create patient only
      const patient = await createPatientMutation.mutateAsync(data);
      toast.success('Patient created successfully');
      
      // Navigate to patient profile where user can add visit and prescription
      navigate(`/patients/${patient.id}`);
    } catch (error) {
      toast.error('Failed to create patient. Please try again.');
      console.error('Error creating patient:', error);
    }
  };

  const isLoading = createPatientMutation.isPending;

  return (
    <div>
      <PageHeader title="Add Patient" />
      <div className="bg-white rounded-lg shadow-md p-6 max-w-4xl">
        <PatientForm onSubmit={handleSubmit} isLoading={isLoading} />
      </div>
    </div>
  );
};

